// src/lib/apiKey.ts
const LS_KEY = "bp_api_key";
const EMAIL_KEY = "bp_account_email";

function emitAuthChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("bp-auth-changed"));
  }
}

export function getApiKey(): string | null {
  try {
    const v = localStorage.getItem(LS_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function setApiKey(k: string) {
  try { localStorage.setItem(LS_KEY, k.trim()); } catch { /* quota/private browsing */ }
  emitAuthChanged();
}

export function clearApiKey() {
  try { localStorage.removeItem(LS_KEY); } catch { /* quota/private browsing */ }
  emitAuthChanged();
}

export function getRememberedAccountEmail(): string | null {
  try {
    const v = localStorage.getItem(EMAIL_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function setRememberedAccountEmail(email: string) {
  try { localStorage.setItem(EMAIL_KEY, email.trim().toLowerCase()); } catch { /* quota/private browsing */ }
  emitAuthChanged();
}

export function clearRememberedAccountEmail() {
  try { localStorage.removeItem(EMAIL_KEY); } catch { /* quota/private browsing */ }
  emitAuthChanged();
}
